import VortexComponent, {component} from 'Lib/Component';
import users from '@/api/users';

@component({
  name: 'HomePage',
  components: [],
  state: {
    selected: null,
    store_name: null,
    shopifyOauthEnabled: false,
  },
})
export default class HomePage extends VortexComponent {
  load = () => {
    const verificationCheckDiv = document.querySelector(
      '#check-for-verification'
    );

    if (verificationCheckDiv) {
      this.checkUserVerificationStatus();
    }
  };

  async checkUserVerificationStatus() {
    try {
      const data = await users.verifications();

      if (data.data.attributes.email_verified === true) {
        document.querySelector('#check-for-verification').innerText =
          'You are verified, we will be redirecting you in a few seconds.';
        setTimeout(() => {
          window.location.replace('/audiences');
        }, 8000);
      } else {
        setTimeout(() => {
          this.checkUserVerificationStatus();
        }, 5000);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
